import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useDocumentTitle from '../../../components/useDocumentTitle';
import { client } from "../../../config/ipfsConfig";
import { getCollectionList, getCollectionListbyWalletAddress } from '../../../hooks/Collectionhook';
import { getUserByAddress } from '../../../hooks/User';
import { collectionABI } from "../../../config/ABIs/CollectionABI";
import { ethers, getBigInt, toBigInt } from 'ethers';
import { MdDelete, MdKeyboardArrowUp, MdOutlineKeyboardArrowDown } from 'react-icons/md';
import Papa from 'papaparse';
import { FaCirclePlus } from "react-icons/fa6";
import { chainId, contractAddress, SIGNING_DOMAIN_NAME, SIGNING_DOMAIN_VERSION } from '../../../config/BackendUrl';
import { ToastContainer, toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { ContractABI } from '../../../config/ABIs/ContractABI';
import { AddActivityNFT, createNFT } from '../../../hooks/NFTHook';
import { Button, Modal } from "react-bootstrap";
import { Puff } from 'react-loader-spinner';

const BulkMint = () => {
  useDocumentTitle('Mint');

  const [fileUrl, setFileUrl] = useState(null);
  const [type, setType] = useState(null);
  const [fileSize, setFileSize] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [formInput, updateFormInput] = useState({ title: "", price: 0, Royalty: 0, desc: "" });
  const [collection, setCollection] = useState([]);
  const [attributes, setAttributes] = useState([]);
  const [newAttribute, setNewAttribute] = useState({});
  const [propertiesFile, setPropertiesFile] = useState(null);
  const [csvFileName, setCsvFileName] = useState(null);
  const [userData, setUserData] = useState({});
  const [show, setShow] = useState(false);
  const [collectionshow, setCollectionshow] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const [errorMessages, setErrorMessages] = useState({});
  const [assetError, setAssetError] = useState('');
  const [selectObj, setSelectObj] = useState({ logo: "img/logos/dtoc.png", name: "DtoC", symbol: "D2C", contractAddress: contractAddress });
  const [nfts, setNfts] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [bulkShow, setBulkShow] = useState(false);
  const walletAddress = localStorage.getItem("WalletAddress");
  const route = useNavigate();
  const PROVIDER = useSelector((state) => state.valueFromHeader);
  const userId = localStorage.getItem("userId");
  const [isTransacting, setIsTransacting] = useState(false);
  const [autoClose, setAutoClose] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    try {
      getUserByAddress(walletAddress).then((data) => {
        setUserData(data.user);
      });
      const Query = { ownerAddress: walletAddress };
      getCollectionListbyWalletAddress(Query).then((data) => {
        console.log("Collection list", data, data.data);

        if (data.success) {
          const Collect = data.data;
          setCollection(Collect);
        }
      })
    }
    catch {
      console.log("Wallet is not Connected !!!");

    }
  }, [walletAddress]);

  const closeButton = () => {
    setFileUrl(null)
  }

  const CloseGallery = (id) => {
    const updateGallery = nfts.filter((data, index) => index !== id)
    console.log("update", updateGallery, id);
    setNfts(updateGallery)
  }
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const url = URL.createObjectURL(file);  // Create file URL for preview
      const type = file.type;  // Get file MIME type
      const size = file.size;  // Get file size
      setFileName(file.name);
      // setFileUrl(url);  // Set file URL
      setType(type);  // Set MIME type
      setFileSize(size);  // Set file size

      // Validate the file
      const error = validateAsset(url, type, size);
      console.log("error", error);
      if (error) {
        setAssetError(error);  // Show error message if validation fails
        console.log("1");
      } else {
        console.log("0");
        setAssetError("");  // Clear error if validation passes
        try {
          const added = await client.add(file);
          const url = `https://ipfs.infura.io/ipfs/${added.path}`;
          setFileUrl(url);
        } catch (error) {
          toast.error("Error uploading file: ", error);
        }
      }
    }
  };
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };
  const validateAsset = (fileUrl, fileType, fileSize) => {
    let error = null;

    // Check if file is uploaded
    if (!fileUrl) {
      error = "Please upload an asset (image or video).";
    } else {
      // Check if file is an image or video
      const fileMimeType = fileType && fileType.split('/')[0];

      // Validate image size (max 1 MB)
      if (fileMimeType === "image") {
        if (fileSize > 50 * 1024 * 1024) {  // 1 MB in bytes
          error = "Image size exceeds 1 MB.";
        }
      }

      // Validate video size (max 10 MB)
      if (fileMimeType === "video") {
        if (fileSize > 50 * 1024 * 1024) {  // 10 MB in bytes
          error = "Video size exceeds 10 MB.";
        }
      }

      // Validate file type (only image and video are allowed)
      if (fileMimeType !== "image" && fileMimeType !== "video") {
        error = "Only images (PNG, GIF, WEBP) and videos (MP4) are allowed.";
      }
    }

    return error;
  };

  const handleChange = (e) => {
    updateFormInput({
      ...formInput,
      [e.target.name]: e.target.value,
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewAttribute({ ...newAttribute, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (newAttribute.trait_type !== "" && newAttribute.value !== "") {
      setAttributes([...attributes, newAttribute]);
      setNewAttribute({ trait_type: '', value: '' });
    }
  };

  const onJsonChange = (event) => {
    const uploadedFile = event.target.files[0];
    setCsvFileName(event.target.files[0].name);
    if (uploadedFile) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const csvData = event.target.result;
        const parsedData = Papa.parse(csvData, { header: true });
        setPropertiesFile(parsedData.data);
      };
      reader.readAsText(uploadedFile);
    } else {
      console.error("Please select a CSV file");
    }
  };

  const handleDelete = (index) => {
    const newAttributes = attributes.filter((_, i) => i !== index);
    setAttributes(newAttributes);
  };

  const updateStateByIndex = (index, newState, obj, stateValue) => {
    setIsSelected(stateValue);
    setCollectionshow(false);
    setSelectObj(obj);
    // getCollectionListbyWalletAddress(walletAddress).then((data) => {
    // const Collect = data.data;
    const GetCollection = collection.map((item) => ({ ...item, isActive: false }));
    if (index) {
      const newArray = GetCollection.filter((_, i) => i !== index).map((item, i) => {
        if (i === index) {
          return { ...item, isActive: newState };
        }
        if (newState === true && i !== index) {
          return { ...item, isActive: false };
        }
        return item;
      });
      setCollection(newArray);
    }
    // }
    // );
  };

  const uploadArrayToIPFS = async (arr, formInput) => {
    const urls = [];

    console.log("item", arr, formInput);

    for (const item of arr) {
      try {
        // Convert the object to a JSON string
        const data = JSON.stringify(item);

        // Upload the data to IPFS
        const added = await client.add(data);

        // Construct the URL and add it to the array
        const url = `https://dtoc.infura-ipfs.io/ipfs/${added.path}`;
        urls.push(url);

      } catch (error) {
        console.error("Error uploading to IPFS:", error);
      }
    }
    return urls;
  };

  const uploadArrayForPrices = (nfts) => {
    try {
      return nfts.map((nft) => ethers.parseEther(nft.price.toString()).toString());
    } catch (error) {
      console.error("Error converting prices to Wei:", error);
      throw error;
    }
  }

  const CreateMint = async () => {

    if (!walletAddress) {
      toast.error("Please Connect Wallet First");
    } else {
      if (isSelected) {
        // for other collection contract  
        if (isChecked) {
          if (nfts.length === 0) {
            console.log("single Other Collection by  mint 000");
            // await SingleNFTOtherCollection()
            setBulkShow(true);
          }
          else {
            console.log("Other Collection by bulk mint");
            // await OtherCollection();
            setBulkShow(true);
          }
        }
        else {
          console.log("Other Collection by  mint");
          // await SingleNFTOtherCollection()
          setBulkShow(true);
        }
      } else {
        // for Dtoc contract
        if (isChecked) {
          if (nfts.length === 0) {
            console.log("Dtoc Collection by  mint");

            await SingleNFTDtocCollection()
          }
          else {
            console.log("Dtoc Collection by bulk mint");
            await DtocCollection();
          }
        }
        else {
          console.log("not checked Dtoc Collection by  mint");
          await SingleNFTDtocCollection()
        }

      }
    }
  };

  const SingleNFTOtherCollection = async () => {
    const toastId = pendingToast("Processing Single NFT Mint...");
    setIsTransacting(true);
    setAutoClose(false)
    try {
      // transactionToast = createTransactionToast("Processing Single NFT Mint...");

      let url;
      let dataObject = {
        title: formInput.title,
        type: type,
        desc: formInput.desc,
        category: formInput.category,
        image: fileUrl,
        creator: userData?.name,
      };

      if (attributes.length !== 0) {
        dataObject.attributes = attributes;
      }

      if (propertiesFile !== null) {
        dataObject.properties = propertiesFile;
      }

      const data = JSON.stringify(dataObject);


      try {
        // Convert the object to a JSON string
        const dataBuffer = Buffer.from(JSON.stringify(dataObject));

        // Add the JSON buffer to IPFS
        const added = await client.add(dataBuffer);

        // Generate the IPFS URL
        url = `https://dtoc.infura-ipfs.io/ipfs/${added.path}`;

      } catch (error) {
        console.error("Error adding data to IPFS:", error);
      }
      toast.update(toastId, {
        render: (
          <div className="d-flex align-items-center">
            <Puff size={20} color="#CC0000" />
            <span className="ml-2">Processing transaction...</span>
          </div>
        )
      });
      const wallet = await PROVIDER.getSigner();
      console.log("receiipt", selectObj.contractAddress, wallet, collectionABI);

      const contracts = new ethers.Contract(
        selectObj.contractAddress,
        collectionABI,
        wallet
      );
      const royaltyFraction = formInput.Royalty * 100;
      console.log("receiipt", walletAddress,
        url,
        royaltyFraction);

      const test = await contracts.safeMint(
        walletAddress,
        url,
        royaltyFraction
      );
      console.log("step 4 => contracts and body", contracts, walletAddress,
        url,
        royaltyFraction);
      toast.update(toastId, {
        render: (
          <div className="d-flex align-items-center">
            <Puff size={20} color="#CC0000" />
            <span className="ml-2">Waiting for confirmation...</span>
          </div>
        )
      });
      const receipt = await test.wait();
      console.log("receiipt", receipt);


      if (receipt) {
        const transferEventSignatures = ethers.keccak256(ethers.toUtf8Bytes("Transfer(address,address,uint256)"));
        // Filter logs for Transfer events
        const logs = receipt.logs.filter((log) => log.topics[0] === transferEventSignatures);
        console.log("Minted Token ID:", logs);

        let tokenId, from, to, transactionHash;
        if (logs.length > 0) {
          logs.forEach((log) => {
            const rawFrom = log.topics[1];
            const rawTo = log.topics[2];
            // Decode the 'from' and 'to' addresses, handling zero address scenarios
            from = rawFrom !== `0x${"0".repeat(64)}` ? ethers.getAddress(rawFrom.slice(-40)) : "Minting (no from)";
            to = rawTo !== `0x${"0".repeat(64)}` ? ethers.getAddress(rawTo.slice(-40)) : "Burning (no to)";
            tokenId = getBigInt(log.topics[3]).toString();
            transactionHash = log.transactionHash;
            console.log("Minted Token ID:", tokenId, from, to, transactionHash);
            const NFTbody = {
              tokenUri: url,
              imageUri: fileUrl,
              tokenId: tokenId,
              title: formInput.title,
              description: formInput.desc,
              walletAddress: walletAddress,
              royaltyFraction: formInput.Royalty * 100,
              price: formInput.price,
              contractAddress: selectObj.contractAddress,
              category: formInput.category,
              assetType: type,
              transactionHash: transactionHash,
              listed: true,
              type: "Direct Mint",
              creator: {
                userId: userId,
                walletAddress: walletAddress
              },
              currentOwner: {
                userId: userId,
                walletAddress: walletAddress
              },
              activity: [{
                event: "Minted",
                price: "0",
                from: 0x0000000000000000000000000000000000000000,
                to: to
              }]
            }

            console.log("NFTbody", NFTbody);
            createNFT(NFTbody).then(async (data) => {
              if (data.success) {
                toast.dismiss(toastId);
                toast(<CustomSuccessToast
                  transactionHash={transactionHash}
                  collectionAddress={contractAddress}
                  nftId={data.data._id}
                  tokenId={tokenId}
                />);
                setBulkShow(!bulkShow)
                setAutoClose(true)
                setTimeout(() => {
                  window.reload();
                }, 2000);
              }
            })
          });
        } else {
          toast.dismiss(toastId);
          toast.error("Unable to find Transfer event in transaction logs.", 'error');
          setAutoClose(true)

        }
      }
    } catch (error) {
      toast.dismiss(toastId);
      console.error("Minting error:", error);
      toast.error(error.reason || "Minting failed. Please try again.", 'error');
      setAutoClose(true)

    }
  };

  console.log("FormData", formInput, nfts, attributes);

  const SingleNFTDtocCollection = async () => {
    console.log("dtoc Collection");

    const toastId = pendingToast("Processing Single NFT Mint...");
    setIsTransacting(true);
    setAutoClose(false)
    try {
      // transactionToast = createTransactionToast("Processing Single NFT Mint...");
      let url;
      let dataObject = {
        title: formInput.title,
        type: type,
        desc: formInput.desc,
        category: formInput.category,
        image: fileUrl,
        creator: userData?.name,
      };

      if (attributes.length !== 0) {
        dataObject.attributes = attributes;
      }

      if (propertiesFile !== null) {
        dataObject.properties = propertiesFile;
      }

      const data = JSON.stringify(dataObject);
      toast.update(toastId, {
        render: (
          <div className="d-flex align-items-center">
            <Puff size={20} color="#CC0000" />
            <span className="ml-2">Processing transaction...</span>
          </div>
        )
      });

      const added = await client.add(data);
      url = `https://dtoc.infura-ipfs.io/ipfs/${added.path}`;
      const wallet = await PROVIDER.getSigner();
      const contracts = new ethers.Contract(
        contractAddress,
        ContractABI,
        wallet
      );
      const price = ethers.parseEther(formInput.price);
      const test = await contracts.createToken(
        url,
        price
      );
      toast.update(toastId, {
        render: (
          <div className="d-flex align-items-center">
            <Puff size={20} color="#CC0000" />
            <span className="ml-2">Waiting for confirmation...</span>
          </div>
        )
      });
      const receipt = await test.wait();

      console.log("receipt", receipt, attributes);

      if (receipt) {
        const transferEventSignatures = ethers.keccak256(ethers.toUtf8Bytes("Transfer(address,address,uint256)"));
        // Filter logs for Transfer events
        const logs = receipt.logs.filter((log) => log.topics[0] === transferEventSignatures);
        let tokenId, from, to, transactionHash;
        if (logs.length > 0) {
          logs.forEach((log) => {
            // Extract tokenId directly from topics[3]
            const rawFrom = log.topics[1];
            const rawTo = log.topics[2];
            // Decode the 'from' and 'to' addresses, handling zero address scenarios
            from = rawFrom !== `0x${"0".repeat(64)}` ? ethers.getAddress(rawFrom.slice(-40)) : "Minting (no from)";
            to = rawTo !== `0x${"0".repeat(64)}` ? ethers.getAddress(rawTo.slice(-40)) : "Burning (no to)";

            transactionHash = log.transactionHash;
            tokenId = getBigInt(log.topics[3]).toString();
            console.log("Minted Token ID:", tokenId, from, to, transactionHash);

            const NFTbody = {
              imageUri: fileUrl,
              tokenUri: url,
              tokenId: tokenId,
              title: formInput.title,
              description: formInput.desc,
              walletAddress: walletAddress,
              price: formInput.price,
              attributes: attributes,
              contractAddress: contractAddress,
              category: formInput.category,
              assetType: type,
              transactionHash: transactionHash, // Add transaction hash here
              listed: true,
              type: "Direct Mint",
              creator: {
                userId: userId,
                walletAddress: walletAddress
              },
              currentOwner: {
                userId: userId,
                walletAddress: walletAddress
              },
              activity: [{
                event: "Minted",
                price: formInput.price,
                from: 0x0000000000000000000000000000000000000000,
                to: to
              }]
            }

            console.log("NFTbody", NFTbody);

            createNFT(NFTbody).then((data) => {
              if (data.success) {
                toast.dismiss(toastId);
                //  toast.success( `Created NFT for TokenId ${tokenId} successfully!`);
                toast(<CustomSuccessToast
                  transactionHash={transactionHash}
                  collectionAddress={contractAddress}
                  nftId={data.data._id}
                  tokenId={tokenId}
                />);
                setAutoClose(true)
                setTimeout(() => {
                  window.reload();
                }, 2000);
              }
            })
          });
        } else {
          toast.dismiss(toastId);
          toast.error("Unable to find Transfer event in transaction logs.", 'error');
          setAutoClose(true)

        }
      }
    } catch (error) {
      toast.dismiss(toastId);
      console.error("Minting error:", error);
      toast.error(error.reason || "Minting failed. Please try again.", 'error');
      setAutoClose(true)
    }
  };

  const OtherCollection = async () => {
    const toastId = pendingToast("Processing Bulk NFT Mint...");
    setIsTransacting(true);
    setAutoClose(false)
    try {
      // transactionToast = createTransactionToast("Processing Bulk NFT Mint...");

      const wallet = await PROVIDER.getSigner();
      const urls = await uploadArrayToIPFS(nfts);
      const royaltyFraction = JSON.stringify(formInput.Royalty * 100);
      toast.update(toastId, {
        render: (
          <div className="d-flex align-items-center">
            <Puff size={20} color="#CC0000" />
            <span className="ml-2">Processing transaction...</span>
          </div>
        )
      });
      console.log("Wallet", urls, selectObj);

      const contracts = new ethers.Contract(
        selectObj.contractAddress,
        collectionABI,
        wallet
      );

      const transaction = await contracts.bulkMint(urls, royaltyFraction);
      toast.update(toastId, {
        render: (
          <div className="d-flex align-items-center">
            <Puff size={20} color="#CC0000" />
            <span className="ml-2">Waiting for confirmation...</span>
          </div>
        )
      });
      const receipt = await transaction.wait();

      if (receipt) {
        const transferEventSignature = ethers.keccak256(
          ethers.toUtf8Bytes("Transfer(address,address,uint256)")
        );

        // Filter logs for Transfer events
        const logs = receipt.logs.filter((log) => log.topics[0] === transferEventSignature);
        let tokenId, from, to, transactionHash;
        if (logs.length > 0) {
          // Map through logs to extract tokenIds and match them with the `nfts` array
          const nftWithTokenIds = logs.map((log, index) => {
            // Extract tokenId from topics[3]
            const rawFrom = log.topics[1];
            const rawTo = log.topics[2];
            // Decode the 'from' and 'to' addresses, handling zero address scenarios
            from = rawFrom !== `0x${"0".repeat(64)}` ? ethers.getAddress(rawFrom.slice(-40)) : "Minting (no from)";
            to = rawTo !== `0x${"0".repeat(64)}` ? ethers.getAddress(rawTo.slice(-40)) : "Burning (no to)";
            transactionHash = log.transactionHash;
            tokenId = getBigInt(log.topics[3]).toString();
            console.log("Minted Token ID:", tokenId);

            // Build the NFT object with the matching `nfts[index]`
            return {
              ...nfts[index], // Include the original NFT data
              tokenId: tokenId, // Add the tokenId
              to: to,
              from: 0,
              url: urls[index],
              transactionHash: transactionHash
            };
          });

          console.log("nftWithTokenIds", nftWithTokenIds);

          // Process and save each NFT with its tokenId
          await Promise.all(
            nftWithTokenIds.map(async (nft, index) => {
              const NFTbody = {
                imageUri: nft.image,
                tokenUri: nft.url,
                tokenId: nft.tokenId,
                title: nft.title || formInput.title,
                description: nft.desc || formInput.desc,
                walletAddress: walletAddress,
                royaltyFraction: royaltyFraction,
                contractAddress: selectObj.contractAddress,
                category: nft.category || nft.category,
                assetType: nft.type,
                transactionHash: nft.transactionHash, // Add transaction hash here
                listed: true,
                type: "Direct Mint",
                creator: {
                  userId: userId,
                  walletAddress: walletAddress,
                },
                currentOwner: {
                  userId: userId,
                  walletAddress: walletAddress,
                },
                activity: [{
                  event: "Minted",
                  price: nft.price,
                  from: 0x0000000000000000000000000000000000000000,
                  to: nft.to
                }]
              };

              console.log("NFTbody", NFTbody);

              const data = await createNFT(NFTbody);
              if (data.success) {
                toast.dismiss(toastId);
                toast(<CustomSuccessToast
                  transactionHash={transactionHash}
                  collectionAddress={contractAddress}
                  nftId={data.data._id}
                  tokenId={tokenId}
                />);
                setAutoClose(true)
                setBulkShow(!bulkShow)
                if (index === nftWithTokenIds.length - 1) {
                  setTimeout(() => {
                    toast.success(
                      "Transaction successful. Created multiple NFTs!"
                    );
                  }, 1000);

                }
                setTimeout(() => {
                  window.reload();
                }, 2000);
              }
            })
          );


        } else {
          toast.dismiss(toastId);
          toast.error("Unable to find Transfer event in transaction logs.", 'error');
          setAutoClose(true)

        }
      }
    } catch (error) {
      toast.dismiss(toastId);
      console.error("Minting error:", error);
      toast.error(error.reason || "Bulk Minting failed. Please try again.", 'error');
      setAutoClose(true)

    }
  };


  const DtocCollection = async () => {
    const toastId = pendingToast("Processing Bulk NFT Mint...");
    setIsTransacting(true);
    setAutoClose(false)
    try {
      // transactionToast = createTransactionToast("Processing Bulk NFT Mint...");

      // Upload NFT data
      const urls = await uploadArrayToIPFS(nfts);
      const prices = await uploadArrayForPrices(nfts);
      console.log("Uploaded URLs:", urls);
      console.log("Prices:", prices);

      // Debug contract address and ABI
      console.log("Contract Address:", contractAddress);
      // console.log("Contract ABI:", ContractABI);
      const functionNames = ContractABI.map((item) => item.name).filter(Boolean);
      // console.log("Function Names in ABI:", functionNames);
      toast.update(toastId, {
        render: (
          <div className="d-flex align-items-center">
            <Puff size={20} color="#CC0000" />
            <span className="ml-2">Processing transaction...</span>
          </div>
        )
      });
      // Create contract instance
      const wallet = await PROVIDER.getSigner();
      const signer = await PROVIDER.getSigner(walletAddress);
      console.log("Signer Address:", await signer.getAddress(), await wallet.getAddress());
      const contract = new ethers.Contract(contractAddress, ContractABI, signer);

      // Ensure method exists in the contract
      if (!contract.bulkMintNFTs) {
        throw new Error("bulkMintNFTs function not found in contract ABI.");
      }

      const transaction = await contract.bulkMintNFTs(walletAddress, urls, prices);
      toast.update(toastId, {
        render: (
          <div className="d-flex align-items-center">
            <Puff size={20} color="#CC0000" />
            <span className="ml-2">Waiting for confirmation...</span>
          </div>
        )
      });
      const receipt = await transaction.wait();
      console.log("Transaction Receipt:", receipt);
      if (receipt) {
        const transferEventSignatures = ethers.keccak256(ethers.toUtf8Bytes("Transfer(address,address,uint256)"));
        // Filter logs for Transfer events
        const logs = receipt.logs.filter((log) => log.topics[0] === transferEventSignatures);
        let tokenId, from, to, transactionHash;

        if (logs.length > 0) {
          // Map through logs to extract tokenIds and match them with the `nfts` array
          const nftWithTokenIds = logs.map((log, index) => {
            // Extract tokenId from topics[3]
            const rawFrom = log.topics[1];
            const rawTo = log.topics[2];
            // Decode the 'from' and 'to' addresses, handling zero address scenarios
            from = rawFrom !== `0x${"0".repeat(64)}` ? ethers.getAddress(rawFrom.slice(-40)) : "Minting (no from)";
            to = rawTo !== `0x${"0".repeat(64)}` ? ethers.getAddress(rawTo.slice(-40)) : "Burning (no to)";
            transactionHash = log.transactionHash;
            tokenId = getBigInt(log.topics[3]).toString();
            console.log("Minted Token ID:", tokenId);

            // Build the NFT object with the matching `nfts[index]`
            return {
              ...nfts[index], // Include the original NFT data
              tokenId: tokenId, // Add the tokenId
              to: to,
              from: 0,
              url: urls[index],
              price: prices[index],
              transactionHash: transactionHash
            };
          });

          console.log("nftWithTokenIds", nftWithTokenIds);

          // Process and save each NFT with its tokenId
          await Promise.all(
            nftWithTokenIds.map(async (nft, index) => {
              const NFTbody = {
                imageUri: nft.image,
                tokenUri: nft.url,
                tokenId: nft.tokenId,
                title: nft.title || formInput.title,
                description: nft.desc || formInput.desc,
                walletAddress: walletAddress,
                price: nft.price,
                contractAddress: selectObj.contractAddress,
                category: nft.category || nft.category,
                assetType: nft.type,
                transactionHash: nft.transactionHash, // Add transaction hash here
                listed: true,
                type: "Direct Mint",
                creator: {
                  userId: userId,
                  walletAddress: walletAddress,
                },
                currentOwner: {
                  userId: userId,
                  walletAddress: walletAddress,
                },
                activity: [{
                  event: "Minted",
                  price: nft.price,
                  from: 0x0000000000000000000000000000000000000000,
                  to: nft.to
                }]
              };

              console.log("NFTbody", NFTbody);

              const data = await createNFT(NFTbody);
              if (data.success) {
                toast.dismiss(toastId);
                toast(<CustomSuccessToast
                  transactionHash={transactionHash}
                  collectionAddress={contractAddress}
                  nftId={data.data._id}
                  tokenId={tokenId}
                />);
                setAutoClose(true)

                if (index === nftWithTokenIds.length - 1) {
                  toast.success(
                    "Transaction successful. Created multiple NFTs!"
                  );

                }
                setTimeout(() => {
                  window.reload();
                }, 2000);
              }
            })
          );

          // setTimeout(() => {
          //   route("/marketplace");
          // }, 2000);
        } else {
          toast.dismiss(toastId);
          toast.error("Unable to find Transfer event in transaction logs.", 'error');
          setAutoClose(true)

        }
        // toast.success("Transaction successful. NFTs minted!");
        // setTimeout(() => {
        //   route("/marketplace");
        // }, 2000);
      }
    } catch (error) {
      toast.dismiss(toastId);
      console.error("Minting error:", error);
      toast.error(error.reason || "Bulk Minting failed. Please try again.", 'error');
      setAutoClose(true)

    }
  };


  const handlePreview = (e) => {
    let dataObject;
    dataObject = {
      title: formInput.title,
      type: type,
      desc: formInput.desc,
      category: formInput.category,
      image: fileUrl,
      creator: userData?.name,
    };
    if (propertiesFile !== null) {
      dataObject.properties = propertiesFile;
    } else if (attributes.length !== 0) {
      dataObject.attributes = attributes;
    }
    else if (formInput.price) {
      dataObject.price = formInput.price
    }
    setNfts([...nfts, dataObject]);

    clearForm(e);
  };

  const clearForm = (e) => {
    e.preventDefault();
    setFileUrl(null);
    setType(null);
    updateFormInput({
      title: "",
      price: "",
      desc: "",
      category: "",
      Royalty: "",
    });
    setFileName(null);
    setAttributes([]);
    setPropertiesFile(null);
    setCsvFileName(null);
    setNewAttribute({ trait_type: '', value: '' });
  };

  const ValidationhandleSubmit = (e, func) => {
    let valid = true;
    let errors = {};

    // 1. Asset Validation (using the validateAsset function)
    const assetError = validateAsset(fileUrl, type, fileSize);
    if (assetError) {
      valid = false;
      errors.asset = assetError;
    }

    // 2. Title Validation
    if (!formInput.title || formInput.title.trim() === "") {
      valid = false;
      errors.title = "Title is required.";
    }


    // 4. Category Validation
    if (!formInput.category || formInput.category === "Select a category") {
      valid = false;
      errors.category = "Please select a category.";
    }

    // 5. Royalty Validation (if not "DtoC")

    if (Number(formInput.Royalty) < 0 || Number(formInput.Royalty) > 100) {
      console.log("Form", formInput);
      valid = false;
      errors.Royalty = "Royalty must be between 0 and 100.";
    }

    // If validation fails, show errors
    if (!valid) {
      setErrorMessages(errors);
    } else {
      // Proceed with the form submission
      if (func === "draft") {
        DraftPost();
      }
      else if (func === "lazy") {
        LazyPost()
      }
      else if (func === "mint") {
        CreateMint()
      }
      if (isChecked) {
        handlePreview(e)
      }
    }
  };

  // check validation and redirect to function
  const NFTMintValid = (e, func) => {
    if (nfts.length > 0) {
      CreateMint()
    }
    else {
      ValidationhandleSubmit(e, func)
    }
  }

  const CallCollectinFuunction = async () => {
    if (isChecked) {
      if (nfts.length === 0) {
        console.log("single Other Collection by  mint 000");
        await SingleNFTOtherCollection()
        // setBulkShow(true);
      }
      else {
        console.log("Other Collection by bulk mint");
        await OtherCollection();
        // setBulkShow(true);
      }
    }
    else {
      console.log("Other Collection by  mint");
      await SingleNFTOtherCollection()
      // setBulkShow(true);
    }
  }

  const LazyPost = async () => {
    // showLoader();
    console.log("Foirm", formInput);
    if (!walletAddress) {
      toast.error("Please Connect Wallet First !!!")
    }
    else if (!userData._id) {
      toast.error("Please Create Profile First !!!")
    }
    else {
      const ContractAddress = selectObj.contractAddress; // Put the address here from remix
      const signer = await PROVIDER.getSigner();

      const domain = {
        name: SIGNING_DOMAIN_NAME,
        version: SIGNING_DOMAIN_VERSION,
        verifyingContract: ContractAddress,
        chainId,
      };
      let url;
      let signature;
      let dataObject = {
        title: formInput.title,
        type: type,
        desc: formInput.desc,
        category: formInput.category,
        image: fileUrl,
        creator: userData?.name,
      };

      if (attributes.length !== 0) {
        dataObject.attributes = attributes;
      }

      if (propertiesFile !== null) {
        dataObject.properties = propertiesFile;
      }

      const data = JSON.stringify(dataObject);



      const royaltyFraction = formInput.Royalty * 100;
      const added = await client.add(data);
      url = `https://dtoc.infura-ipfs.io/ipfs/${added.path}`;

      async function createVoucher(price, uri, royaltyFraction) {
        const voucher = { price, uri, royaltyFraction };
        const types = {
          LazyNFTVoucher: [
            { name: "price", type: "uint256" },
            { name: "uri", type: "string" },
            { name: "royaltyFraction", type: "uint96" },
          ],
        };

        signature = await signer.signTypedData(domain, types, voucher);
        return {
          ...voucher,
          signature,
        };
      }

      const priceInWei = ethers.parseEther(formInput.price);
      await createVoucher(priceInWei, url, toBigInt(royaltyFraction))

      const signatureArr = [signature]
      const NFTbody = {
        imageUri: fileUrl,
        tokenUri: url,
        title: formInput.title,
        description: formInput.desc,
        walletAddress: walletAddress,
        royaltyFraction: formInput.Royalty * 100,
        price: formInput.price,
        contractAddress: selectObj.contractAddress,
        category: formInput.category,
        // transactionHash: receipt.transactionHash, // Add transaction hash here
        signature: signatureArr,
        assetType: type,
        listed: true,
        type: "Lazy Mint",
        creator: {
          userId: userId,
          walletAddress: walletAddress
        },
        currentOwner: {
          userId: userId,
          walletAddress: walletAddress
        }
      }
      console.log("NFTbody", NFTbody);

      createNFT(NFTbody).then((data) => {
        if (data.success) {
          toast.success("Created Lazy NFT successfully !!!")
          setTimeout(() => {
            route('/marketplace');
            // hideLoader();
          }, 2000);
        }
      })

    }
  };

  const DraftPost = async () => {
    // showLoader();

    if (!userData._id) {
      toast.error("Please Create Profile First !!!")
    }
    else {
      let url;
      let dataObject = {
        title: formInput.title,
        type: type,
        desc: formInput.desc,
        category: formInput.category,
        image: fileUrl,
        creator: userData?.name,
      };

      if (attributes.length !== 0) {
        dataObject.attributes = attributes;
      }

      if (propertiesFile !== null) {
        dataObject.properties = propertiesFile;
      }

      const data = JSON.stringify(dataObject);



      const added = await client.add(data);
      url = `https://dtoc.infura-ipfs.io/ipfs/${added.path}`;

      const body = {
        contractAddress: selectObj.contractAddress,
        uri: url,
        walletAddress: walletAddress,
        status: false
      }

      // createNFTDraft(body).then((res) => {
      //   if (res.status === 201) {
      console.log("selectObj", selectObj);

      const NFTbody = {
        contractAddress: selectObj.contractAddress,
        imageUri: fileUrl,
        tokenUri: url,
        title: formInput.title,
        description: formInput.desc,
        walletAddress: walletAddress,
        attributes: attributes,
        royaltyFraction: formInput.Royalty ? Number(formInput.Royalty) * 100 : null,
        price: formInput.price,
        category: formInput.category,
        assetType: type,
        draft: true,
        type: "Direct Mint",
        creator: {
          userId: userId,
          walletAddress: walletAddress
        },
        currentOwner: {
          userId: userId,
          walletAddress: walletAddress
        }

      }
      console.log("NFTbody", NFTbody);

      createNFT(NFTbody).then((data) => {
        if (data.success) {
          toast.success("Created Draft NFT successfully !!!")
          setTimeout(() => {
            route('/profile', { state: "draft" });
            // hideLoader();
          }, 2000);
        }
      })

    }
  };

  const handleBackClick = () => {
    route(-1)
  };

  const pendingToast = (message) => {
    return toast(
      <div className="d-flex align-items-center">
        <Puff size={20} color="#CC0000" />
        <span className="ml-2">{message}</span>
      </div>,
      {
        position: "bottom-right",
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      }
    );
  };
  const CustomSuccessToast = ({ transactionHash, collectionAddress, nftId, tokenId, closeToast }) => {
    const navigate = useNavigate();

    const handleViewDetails = () => {
      // Navigate to the NFT details page
      navigate(`/nftdetails/${collectionAddress}/${nftId}`);
      // Optionally close the toast after navigation
      closeToast();
    };

    const handleViewOnEtherscan = () => {
      // Open the Etherscan URL in a new tab
      const etherscanUrl = `https://sepolia.etherscan.io/tx/${transactionHash}`;
      window.open(etherscanUrl, '_blank');
      // Optionally close the toast after opening the link
      closeToast();
    };

    return (
      <div>
        <p>Created NFT for TokenId {tokenId} successfully!</p>
        <div className="d-flex align-items-center justify-content-between">
          <button className='btn btn-sm btn-grad mr-2' onClick={handleViewDetails}>View Details</button>
          <button className='btn btn-sm btn-grad' onClick={handleViewOnEtherscan}>View on Etherscan</button>
        </div>
      </div>
    );
  };
  return (
    <section className="relative py-24">
      {/* Other JSX and form code */}
      <div className="container"
      //  style={{ pointerEvents: isTransacting ? 'none' : 'auto' }}
      >
        <button
          onClick={handleBackClick}
          className="btn btn-white btn-sm my-20 ml-8"
        >
          Back
        </button>
        <div className="box in__upload mt-40 mb-120" style={{ position: "relative" }}>
          <div className="row">
            <div className="col-lg-6">

              <div className="left__part space-y-40 md:mb-20 upload_file" style={{ height: "70%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                {fileUrl && (
                  <div id="upload_file_close_button" className="closeButton" onClick={closeButton}>
                    X
                  </div>
                )}

                <div className="space-y-20" style={{ width: "100%", textAlign: "center" }}>
                  {type !== null ? (
                    type.split('/')[0] === "image" ? (
                      <div style={{ maxWidth: "100%", overflow: "hidden", display: "flex", justifyContent: "center" }}>
                        {fileUrl && <img src={fileUrl} alt="Asset" style={{ maxWidth: "100%", height: "auto", borderRadius: "10px" }} />}
                      </div>
                    ) : (
                      <video src={fileUrl} autoPlay muted loop style={{ maxWidth: "100%", height: "auto", objectFit: "contain", borderRadius: "10px" }} />
                    )
                  ) : null}
                </div>

                {!fileUrl && (
                  <div className="space-y-20">
                    <p className="color_text">or choose a file</p>
                    <div id="browse_files">
                      <Link to="#" className="btn btn-white">Browse files</Link>
                      <input type="file" onChange={handleFileChange} />
                    </div>
                  </div>
                )}

                {!fileUrl && <p className="color_text">Max size: 50MB <br /> JPG, PNG, GIF, SVG, MP4</p>}
                {assetError && <div className="error-message">{assetError}</div>}
                {fileName && <div style={{ color: "black" }}>{fileName}</div>}
                {errorMessages.asset && <p className="error-message">{errorMessages.asset}</p>}
              </div>

              {/* <NFTGallery /> */}
              {nfts.length !== 0 &&
                <>
                  <h4 className='my-2'>
                    NFTs Gallery
                  </h4>

                  <div className="galleryContainer">
                    {nfts.map((data, index) => (
                      <div className="galleryCard m-2" key={index}>
                        <div id="" className="galleryClose btn-grad" onClick={() => CloseGallery(index)}>
                          X
                        </div>
                        {data.type && data.type.split('/')[0] === "image" ? (
                          data.image && <img src={data.image} alt="Asset" />
                        ) : (
                          <video src={data.image} autoPlay muted loop />
                        )}
                      </div>
                    ))}
                  </div>

                </>
              }
            </div>
            <div className="col-lg-6">
              <div className="form-group space-y-10">
                <div className="space-y-20">
                  <div className='space-y-10 colletion_ui'>
                    <span className="variationInput">Choose collection</span>
                    <div className="d-flex flex-column flex-md-row p-2">
                      <div className={"isSelected_collection d-flex justify-content-between"} onClick={() => setCollectionshow(!collectionshow)}>
                        <div className='d-flex justify-content-start' >
                          <img
                            src={selectObj.logo}
                            alt="Dtoc_icon"
                          />
                          <div>
                            <div>
                              <span className="ml-10">
                                {selectObj.name}
                              </span>
                            </div>
                            <div>
                              <p className="ml-10">
                                {selectObj.symbol}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div>
                          {collectionshow ?
                            <MdKeyboardArrowUp size={32} onClick={() => setCollectionshow(false)} /> :
                            <MdOutlineKeyboardArrowDown size={32} onClick={() => setCollectionshow(true)} />
                          }
                        </div>
                      </div>
                      <div>
                        <div className='d-flex align-items-center justify-content-between ml-3'>
                          <input type="checkbox" name="bulkMint" style={{ width: "1.2rem" }} id="bulkMintcheck"
                            checked={isChecked}
                            onChange={handleCheckboxChange} />
                          <span className='mx-2 fs-6'>
                            Please check for Bulk Mint.
                          </span>
                        </div>
                        {nfts.length !== 0 &&
                          <>
                            <span className='ml-4 mt-3'>{nfts.length} Items</span>
                          </>}
                        <button type="button"
                          onClick={ValidationhandleSubmit}
                          disabled={!isChecked}
                          style={{ float: "right" }} className={`${!isChecked ? "btn-secondary" : "btn-grad"} btn-sm text-white px-4 py-2 mt-2 rounded`}>Add </button>
                      </div>
                    </div>
                    {collectionshow &&
                      <div className='colletion_ui_data'>

                        <div className="d-flex flex-column flex-md-row p-2">
                          <div className={`${isSelected ? "choose_collection" : "isSelected_collection "}  d-flex justify-content-start`} onClick={() => updateStateByIndex(null, true, { logo: "img/logos/dtoc.png", name: "DtoC", symbol: "D2C", contractAddress: contractAddress }, false)}>
                            <img
                              src={`img/logos/dtoc.png`}
                              alt="Dtoc_icon"
                            />
                            <div>
                              <div>
                                <span className=" ml-10">
                                  DtoC
                                </span>

                              </div>
                              <div>
                                <p className=" ml-10">
                                  D2C
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        {collection.length !== 0 &&
                          collection.map((data, i) => (
                            <div className="d-flex flex-column flex-md-row  p-2">
                              <div className={`${data.isActive ? "isSelected_collection" : "choose_collection "}  d-flex justify-content-start`} onClick={() => updateStateByIndex(i, true, data, true)}>

                                <img
                                  src={data !== null ? data.logo : `img/logos/dtoc.png`}
                                  alt="Dtoc_icon"
                                />
                                <div>
                                  <div>
                                    <span className=" ml-10 d-flex">
                                      {data !== null && data.name}
                                    </span>

                                  </div>
                                  <div>
                                    <span className=" ml-10">
                                      {data !== null && data.symbol}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        }
                        <div className="d-flex flex-column flex-md-row p-2">
                          <Link to="/collectionAdd" className="choose_collection d-flex justify-content-start">
                            <FaCirclePlus color='black' size="50" />
                            <div className='align-items-center '>
                              <div>
                                <span className=" ml-10">
                                  Create
                                </span>

                              </div>
                              <div>
                                <p className=" ml-10">
                                  ERC-721
                                </p>
                              </div>
                            </div>
                          </Link>
                        </div>
                      </div>
                    }
                  </div>
                  <div className="space-y-10">
                    <span className="nameInput">Title</span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Title"
                      name='title'
                      onChange={handleChange}
                      value={formInput.title}

                    />
                    {errorMessages.title && <p className="error-message">{errorMessages.title}</p>}

                  </div>
                  {/* {selectObj.name === "DtoC" && */}
                  <div className="space-y-10">
                    <span className="nameInput">
                      Price
                    </span>
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Price"
                      name='price'
                      defaultValue={formInput.price}
                      onChange={handleChange}
                      min="0" // Prevents entering negative numbers
                      step="0.01" // Optional: Allows decimal numbers

                    />
                    {errorMessages.price && <p className="error-message">{errorMessages.price}</p>}
                  </div>
                  {/* // } */}
                  {/* {selectObj.name !== "DtoC" && (
                    <div className="space-y-10 inputs-filds">
                      <span className="nameInput">Royalty</span>
                      <div className="input-container">
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Royalty"
                          name="Royalty"
                          // onChange={handleChange}
                          onChange={(e) => {
                            const value = parseFloat(e.target.value);
                            if (value > 100) {
                              e.target.value = 100; // Set to max value if input exceeds 100
                            }
                            handleChange(e); // Call the change handler
                          }}
                          min="0" // Prevents entering negative numbers
                          max="100" // Prevents entering numbers greater than 100
                          step="0.01" // Optional: Allows decimal numbers
                        />
                        <span className="input-suffix">%</span>
                      </div>
                      {errorMessages.Royalty && <p className="error-message">{errorMessages.Royalty}</p>}
                    </div>
                  )} */}
                  <div className="space-y-10">
                    <span className="nameInput">
                      Description
                    </span>
                    {/* <input
                      type="text"
                      className="form-control"
                      placeholder="Description"
                      name='desc'
                      value={formInput.desc}
                      onChange={handleChange}
                    /> */}
                    <textarea name="desc" className="form-control" id="descfornft" rows="3"
                      placeholder="Description"
                      value={formInput.desc}
                      onChange={handleChange}
                    ></textarea>
                  </div>

                  <div className='space-y-10'>
                    <span className="variationInput">Category</span>
                    <select
                      className="form-select custom-select" style={{ height: "auto" }}
                      aria-label="Default select example" name="category" onChange={handleChange}>
                      <option className="">select a category</option>
                      <option className="" value="Art">
                        Art
                      </option>
                      <option className="" value="Graphics">
                        Graphics
                      </option>
                      <option className="" value="Video">
                        Video
                      </option>
                      <option className="" value="Others">
                        others
                      </option>
                    </select>
                    {errorMessages.category && <p className="error-message">{errorMessages.category}</p>}

                  </div>
                  {show ?
                    <div className='space-y-10'>
                      <div className="d-flex align-items-center justify-content-between">
                        <h4>
                          Attribute
                        </h4>
                        <div>
                          <button
                            className="btn btn-grad space-y-10 mx-10
					btn_create"
                            onClick={() => setShow(false)}
                          >
                            Close
                          </button>
                          <button
                            className="btn btn-grad space-y-10
					btn_create"
                            onClick={handleSubmit}
                          >
                            Add
                          </button>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-6">
                          <span className="nameInput">
                            Trait Type
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Trait Type"
                            name="trait_type"
                            value={newAttribute.trait_type}
                            onChange={handleInputChange}
                          />
                        </div>
                        <div className="col-lg-6">
                          <span className="nameInput">
                            Value
                          </span>
                          <input
                            type="text"
                            className="form-control"
                            name="value"
                            placeholder="Value"
                            value={newAttribute.value}
                            onChange={handleInputChange}
                          />
                        </div>

                      </div>
                    </div>
                    : <button
                      className="btn btn-grad space-y-10 btn_create"
                      onClick={() => setShow(true)}
                    >
                      Add Attribute
                    </button>}
                  {attributes.length !== 0 &&
                    <>
                      <p className="my-3">Attributes:</p>
                      <div className="table-responsive">
                        <table
                          id="user-list-table"
                          className="table table-hover"
                          role="grid"
                          data-toggle="data-table"
                        >
                          <thead>
                            <tr className="ligth">
                              <th className="text-center">SNo.</th>
                              <th className="text-center">Trait Type</th>
                              <th className="text-center">Value</th>
                              <th className="text-center">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {attributes.map((attr, i) => {
                              return (
                                <tr key={i}>
                                  <td className="text-center">{i + 1}</td>
                                  <td className="text-center">{attr.trait_type}</td>
                                  <td className="text-center">{attr.value}</td>
                                  <td className="text-center" onClick={() => handleDelete(i)} > <MdDelete color="red" /> </td>

                                </tr>
                              )
                            })}
                          </tbody>
                        </table>
                      </div>
                    </>
                  }
                  <div className="space-y-10 upload_file">
                    <button
                      className="btn btn-grad
					btn_create"
                      onClick={CreateMint}
                    >
                      Upload Properties File
                    </button>
                    <input type="file" accept=".csv" onChange={onJsonChange} />
                  </div>
                  {csvFileName}
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-auto col-12 mb-20 mt-2" style={{ position: "absolute", bottom: "0px", right: "0px" }}>
            {nfts.length === 0 &&
              <>
                <button className="btn btn-grad btn_create mr-3"
                  // onClick={SingleNFTDtocCollection}
                  onClick={(e) => { selectObj.name === "DtoC" ? ValidationhandleSubmit(e, "draft") : setBulkShow(!bulkShow) }}

                >
                  Draft Mint
                </button>
                {selectObj.name !== "DtoC" && (
                  <button className="btn btn-grad btn_create mr-3" onClick={(e) => setBulkShow(!bulkShow)}>
                    Lazy Mint
                  </button>
                )}
              </>
            }
            <button className="btn btn-grad btn_create" onClick={(e) => NFTMintValid(e, "mint")}>
              Mint NFT
            </button>
          </div>
        </div>
      </div>
      <ToastContainer
        position="bottom-right"
        newestOnTop={true}
        autoClose={false}
        closeOnClick={false}
        closeButton={autoClose}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
      />
      {/* <CustomSucc zessToast />/ */}
      <Modal show={bulkShow} size="lg" onHide={() => setBulkShow(!bulkShow)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Add Royalty</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h3>Add Royalty for Bulk Mint for Collection {`${selectObj.name}`}</h3>

          <div className='my-4'>
            <div className="space-y-10 inputs-filds">
              <span className="nameInput">Royalty</span>
              <div className="input-container">
                <input
                  type="number"
                  className="form-control"
                  placeholder="Royalty"
                  name="Royalty"
                  // onChange={handleChange}
                  onChange={(e) => {
                    const value = parseFloat(e.target.value);
                    if (value > 100) {
                      e.target.value = 100; // Set to max value if input exceeds 100
                    }
                    handleChange(e); // Call the change handler
                  }}
                  min="0" // Prevents entering negative numbers
                  max="100" // Prevents entering numbers greater than 100
                  step="0.01" // Optional: Allows decimal numbers
                />
                <span className="input-suffix">%</span>
              </div>
              {errorMessages.Royalty && <p className="error-message">{errorMessages.Royalty}</p>}
            </div>
          </div>


        </Modal.Body>
        <Modal.Footer className='d-flex align-items-center justify-content-between'>
          <Button onClick={() => setBulkShow(!bulkShow)}>Cancel</Button>
          <div>

            <Button
            onClick={(e) => ValidationhandleSubmit(e, "draft")}>Draft</Button>

            {nfts.length === 0 && <Button 
            className='ml-3'
            onClick={(e) => LazyPost(e, "lazy")}>Lazy Mint</Button>}
            <Button
            className='ml-3'
              onClick={() => CallCollectinFuunction()}
              disabled={Number(formInput.Royalty) < 0 || Number(formInput.Royalty) > 100 ? true : false}
            >
              Mint NFT
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </section>
  );
};

export default BulkMint;


